import { render, staticRenderFns } from "./ConfirmFormDialog.vue?vue&type=template&id=665c28ed&lang=pug"
import script from "./ConfirmFormDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports